import { combineReducers } from 'redux'

import { soyshareApi } from '../../services/api'
import alert from '../ducks/alert'
import auth from '../ducks/auth/auth'
import passwordRecovery from '../ducks/auth/passwordRecovery'
import resetPassword from '../ducks/auth/resetPassword'
import reports from '../ducks/reports'
import loading from '../ducks/loading'

import Settings from './Settings'

const combinedReducers = combineReducers({
  [soyshareApi.reducerPath]: soyshareApi.reducer,
  settings: Settings,
  loading,
  alert,
  auth,
  passwordRecovery,
  resetPassword,
  [reports.reducerPath]: reports.reducer
})

export default combinedReducers
